/* This is similar to admin/filter_select_options.js but different! */

(function($) {

function arrayContains(array, item) {
    /* Shortcut for checking if an item is within an array. */
    return $.inArray(array, item) != -1;
}

$.fn.filterSelect = function(settings, autosize) {

    var registry = [];
    var delayTimer;
    var $originalOptions;

    function update($affected) {
        /*
        Update a select element. It will use the registry to figure out
        what related things are selected and what options to display.
        */

        // When updating an element for the first time, move all of the
        // options into the originalOptions variable. The filtered options
        // will always be cloned from these options.
        if ($originalOptions == undefined) {
            $originalOptions = $('<select></select>');
            $affected.find('option').each(function() {
                $originalOptions.append($(this));
            });
        }

        // Find out which values are selected on the affected element,
        // so they can be reselected after recreating the options.
        // This is NOT used to determine which options to show/hide.
        var selection = $affected.find('option:selected').map(function() { return this.value });

        // Now create a new set of options based on the select values.
        $affected.find('option').remove();
        $originalOptions.find('option').each(function() {

            var $option = $(this);

            var displayOption = true;

            // Loop through each element that is being watched / used for
            // filtering, to determine if this option should be displayed.
            if ($option.val()) {
                $.each(registry, function() {
                    var $watched = this[0],
                        settings = this[1],
                        selectedValues,
                        optionData = $option.attr('data-' + settings.data),
                        supportedValues = (optionData || '').split(',');

                    displayOption = false;

                    if ($watched.hasClass('filtered')) {
                        // This is a Django filter_horizontal widget.
                        // Look at all options in the "chosen" select element,
                        // not caring which ones are actually selected.
                        selectedValues = $watched
                                        .parents('.selector')
                                        .find('.selector-chosen select option')
                                        .map(function(){ return this.value });
                    } else {
                        // It's a plain old select element.
                        // Get the selected values as usual.
                        selectedValues = $watched.val() || [];
                        selectedValues = selectedValues['push'] && selectedValues || [selectedValues];
                    }

                    if (settings.require_all) {
                        // The option must support all selected values
                        // for it to be made visible.
                        $.each(selectedValues, function() {
                            var selectedValue = String(this);
                            if (arrayContains(selectedValue, supportedValues)) {
                                // Tentatively include this option. It will
                                // keep looping and check all selected values.
                                displayOption = true;
                            } else {
                                displayOption = false;
                            }
                            // This will stop looping through the selected
                            // values if the option is not going to be included.
                            return displayOption;
                        })
                    } else {
                        // The option need only support any 1 selected value
                        // for it to be made visible. Initially set it hidden,
                        // but change it if/when a supported value is found.
                        $.each(selectedValues, function() {
                            var selectedValue = String(this);
                            if (arrayContains(selectedValue, supportedValues)) {
                                // Include this option.
                                displayOption = true;
                                // Stop looking.
                                return false;
                            }
                        });
                    }

                    if (selectedValues.length == 0 && supportedValues[0] == "") {
                        // If we have empty selectedValues & supportedValues
                        // then show the option
                        displayOption = true;
                    }

                    if (!displayOption) {
                        // If we are definitely not including this option
                        // then there is no need to continue looping through
                        // the watched elements registry.
                        return false;
                    }

                });
            }

            // If the option is to be displayed, then clone it into
            // the target/affected select element.
            if (displayOption) {
                var $newOption = $option.clone().appendTo($affected);
                // Reselect the option if it was selected before.
                if (arrayContains($newOption.val(), selection)) {
                    $newOption.attr('selected', 'selected');
                }
            }

        });

        // Automatically set the size (height) based on the number of
        // visible options. Do not exceed 25.
        if (autosize) {
            var size = Math.max(Math.min($affected.find('option').length, 25), 1);
            $affected.attr('size', size);
        }

        // Trigger a change event so other code can react.
        $affected.change();

    }

    function watch($watched, $affected) {
        if ($watched.hasClass('selectfilter')) {
            // The selectfilter class shows that it's using Django's
            // filter_horizontal widget, which has its own crazy JavaScript.
            // When this is the case, delay the event handlers by 1
            // millisecond so that the Django JS will run first.
            $watched.parents('.form-row').delegate('a, select', 'click dblclick', function() {
                var $select = $(this).parents('.selector').find('.selector-chosen select');
                clearTimeout(delayTimer);
                delayTimer = setTimeout(function() {
                    update($affected);
                }, 1);
            });
            clearTimeout(delayTimer);
            delayTimer = setTimeout(function() {
                $watched.parents('.form-row').find('select').click()
            }, 1);
        } else {
            // Watching a plain old select element. When it gets changed,
            // update the affected element using the new values.
            $watched.bind('change', function() {
                update($affected);
            });
            $watched.change();
        }
    }

    if (!settings) {
        return this;
    }

    return this.each(function() {
        var $affected = $(this);
        for (watchedId in settings) {
            var $watched = $('#' + watchedId);
            if ($watched.length) {
                registry.push([$watched, settings[watchedId]]);
                watch($watched, $affected);
            }
        }
    });
}

})(jQuery);